import { monthsSince, ageText, petAgeError } from "@/lib/petAge";

const num = (s) => (s === "" ? null : Math.max(0, parseInt(s, 10) || 0));

// Required age (years + months). When a valid DOB is entered the age is derived from it (read-only).
export function PetAgeField({ value = {}, onChange, testid = "pet-age", showError = false }) {
  const fromDob = monthsSince(value.dob);
  const err = showError ? petAgeError(value) : "";
  const cls = "w-full rounded-lg border bg-white px-3 py-2 text-sm text-slate-900 min-h-[44px] outline-none focus:border-emerald-500 " + (err ? "border-rose-300" : "border-slate-200");
  return (
    <div data-testid={testid}>
      <div className="text-[11px] font-semibold text-slate-500">Age <span className="text-rose-500">*</span></div>
      {fromDob != null ? (
        <div className="mt-1 rounded-lg border border-emerald-100 bg-emerald-50 px-3 py-2 text-sm text-emerald-800" data-testid={`${testid}-from-dob`}>
          {ageText(fromDob)} <span className="text-[11px] text-emerald-600">(from date of birth)</span>
        </div>
      ) : (
        <div className="mt-1 grid grid-cols-2 gap-2">
          <label className="text-[11px] text-slate-500">Years
            <input type="number" inputMode="numeric" min={0} max={40} value={value.age_years ?? ""} data-testid={`${testid}-years`}
              onChange={(e) => onChange({ age_years: num(e.target.value) })} className={cls} placeholder="e.g. 2" /></label>
          <label className="text-[11px] text-slate-500">Months
            <input type="number" inputMode="numeric" min={0} max={11} value={value.age_months ?? ""} data-testid={`${testid}-months`}
              onChange={(e) => onChange({ age_months: num(e.target.value) })} className={cls} placeholder="0–11" /></label>
        </div>
      )}
      {fromDob == null && (value.age_years != null || value.age_months != null) && !petAgeError(value) && (
        <p className="mt-1 text-[11px] text-slate-500" data-testid={`${testid}-readable`}>{ageText((value.age_years || 0) * 12 + (value.age_months || 0))}</p>
      )}
      {err && <p className="mt-1 text-xs text-rose-600" data-testid={`${testid}-error`}>{err}</p>}
    </div>
  );
}
